import React, { Component } from "react";

import KodeDecodeText from "../effects/KodeDecodeText";
import styles from "./KodeWelcome.module.css";
import { KODE_PATHS, KODE_VIEWBOX } from "../KodeLogo/paths";

// Строка-версия, а не булево: будущий редизайн покажет интро один раз, если
// бампнуть значение.
export const WELCOME_SEEN_KEY = "kode.welcome.seen";
export const WELCOME_SEEN_VERSION = "1";
export const WELCOME_PENDING_KEY = "kode.welcome.pending";

const FULL_DURATION_MS = 4200;
const REDUCED_DURATION_MS = 1800;
const LEAVE_MS = 380;

const prefersReducedMotion = () =>
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const shouldShowWelcome = () => {
  const pending = sessionStorage.getItem(WELCOME_PENDING_KEY) === "1";
  const neverSeen = localStorage.getItem(WELCOME_SEEN_KEY) !== WELCOME_SEEN_VERSION;
  return pending || neverSeen;
};

export const replayWelcome = () => {
  localStorage.removeItem(WELCOME_SEEN_KEY);
  sessionStorage.setItem(WELCOME_PENDING_KEY, "1");
};

/**
 * Приветствие после логина / при первом входе. Раскадровка (мс):
 * 0-500 дымка · 120-1120 отрисовка логотипа обводкой · 1120-1320 кросс-фейд в
 * заливку · 900-1500 волосяная линия · 1000-1300 надзаголовок · 1300-2200
 * decode заголовка · 1500-2100 скан-линия · 1800-2400 подпись · 2600-2840 уход.
 */
class KodeWelcome extends Component {
  constructor(props) {
    super(props);
    this.reducedMotion = prefersReducedMotion();
    this.state = { leaving: false };
    this.finishTimer = null;
    this.leaveTimer = null;
    this.skipRef = React.createRef();
  }

  componentDidMount() {
    sessionStorage.removeItem(WELCOME_PENDING_KEY);
    localStorage.setItem(WELCOME_SEEN_KEY, WELCOME_SEEN_VERSION);
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.handleKeyDown);
    this.finishTimer = setTimeout(
      this.dismiss,
      this.reducedMotion ? REDUCED_DURATION_MS : FULL_DURATION_MS
    );
    if (this.skipRef.current) {
      this.skipRef.current.focus();
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.handleKeyDown);
    clearTimeout(this.finishTimer);
    clearTimeout(this.leaveTimer);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      this.dismiss();
    }
  };

  dismiss = () => {
    if (this.state.leaving) {
      return;
    }
    clearTimeout(this.finishTimer);
    this.setState({ leaving: true });
    this.leaveTimer = setTimeout(this.props.onDone, LEAVE_MS);
  };

  render() {
    return (
      <div
        className={`${styles.overlay} ${this.state.leaving ? styles.overlayLeaving : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Welcome to the KODE QA Platform"
        onClick={this.dismiss}
      >
        <div className={styles.haze} aria-hidden="true" />
        <div className={styles.stage}>
          <svg
            viewBox={KODE_VIEWBOX}
            height="48"
            aria-hidden="true"
            focusable="false"
            style={{ display: "block", margin: "0 auto" }}
          >
            <g>
              {KODE_PATHS.map((pathData) => (
                <path key={`fill-${pathData.slice(0, 12)}`} className={styles.logoFill} d={pathData} />
              ))}
              {KODE_PATHS.map((pathData) => (
                <path
                  key={`stroke-${pathData.slice(0, 12)}`}
                  className={styles.logoStroke}
                  d={pathData}
                />
              ))}
            </g>
          </svg>

          <div className={styles.rule} aria-hidden="true" />
          <div className={styles.eyebrow}>QA Platform</div>

          <div className={styles.headline}>
            {this.reducedMotion ? (
              "KODE AI Transformation"
            ) : (
              <KodeDecodeText text="KODE AI Transformation" />
            )}
            {!this.reducedMotion && <span className={styles.scan} aria-hidden="true" />}
          </div>

          {/* Тот же слоган, что и в интро на главной, и тем же цветом —
              иначе первый экран и главная говорили бы разными голосами. */}
          <div className={styles.tagline}>A new age of quality</div>

          <div className={styles.subline}>
            Allure test reports · every service · one place
          </div>
        </div>

        <button type="button" className={styles.skip} onClick={this.dismiss} ref={this.skipRef}>
          Skip
        </button>
      </div>
    );
  }
}

export default KodeWelcome;
